import React, { useEffect } from "react";

import modalConstants from "../reusables/modal/modalConstants";
import { useDispatch, useSelector } from "react-redux";
import { connectWallet } from "../../redux/actions";
import { useNavigate } from "react-router-dom";
// import Loader from "../reusables/loader";
// import SelectBlockchain from "../auth/SelectBlockchain";
import SelectNetwork from "../auth/SelectNetwork";
import styled from "styled-components";
import Masthead from "./Sections/MastHead";
import Achievements from "./Sections/Achievements";
import Features from "./Sections/Features";
import HowItWorks from "./Sections/HowItWorks";
import Compare from "./Sections/Comparism";
import FAQ from "./Sections/FAQs";
import Footer from "../reusables/Navs/Footer";
import Header from "../reusables/Navs/Header";
import SupportedNetworks from "./Sections/SupportedNetworks";
import GetStarted from "./Sections/GetStarted";
import Partners from "./Sections/Partners";

const LandingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  gap: 100px;
  z-index: 100;

  @media (min-width: 768px) {
    padding: 30px 50px;
  }

  .top-space {
    margin-top: 30px;
  }
`;

const ParentContainer = styled.div`
  position: relative;
  overflow: hidden;

  img.blob {
    position: absolute;
    opacity: 0.5;
    z-index: 0;
    pointer-events: none;
    user-select: none;
    max-width: 100%;
    height: auto;
  }

  .blob-1 {
    top: -100px;
    right: -200px;
    transform: scale(1.2);
  }

  .blob-2 {
    top: 600px;
    left: -250px;
    transform: scale(1);
  }

  .blob-3 {
    top: 1300px;
    right: -200px;
    transform: scale(1.1);
  }

  .blob-4 {
    top: 2000px;
    left: -150px;
    transform: scale(1);
  }

  .blob-5 {
    top: 2700px;
    right: -150px;
    transform: scale(1.2);
  }

  @media (max-width: 768px) {
    .blob-1,
    .blob-2,
    .blob-3,
    .blob-4,
    .blob-5 {
      transform: scale(0.8);
      opacity: 0.3;
    }
  }
`;

export const Landing = ({ currentTheme, themeToggler }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.persistedStore);
  const modalPage = useSelector((state) => state.GeneralReducer.modalPage);
  const connectToNetwork = async (network) => {
    dispatch(connectWallet(network));
  };

  useEffect(() => {
    if (auth.isConnected) {
      navigate("/multisend");
    }
  }, [auth, navigate]);

  return (
    <ParentContainer style={{ position: "relative", width: "100%" }}>
      {currentTheme === "dark" && (
        <>
          <img
            src="/assets/img/SVG/blob-1.svg"
            className="blob blob-1"
            alt="blob-1"
            style={{ zIndex: 1 }}
          />
          <img
            src="/assets/img/SVG/blob-2.svg"
            className="blob blob-2"
            alt="blob-2"
          />
          <img
            src="/assets/img/SVG/blob-3.svg"
            className=" blob blob-3"
            alt="blob-3"
          />
          <img
            src="/assets/img/SVG/blob-4.svg"
            className="blob blob-4"
            alt="blob-4"
          />
          <img
            src="/assets/img/SVG/blob-5.svg"
            className="blob blob-5"
            alt="blob-5"
          />
        </>
      )}
      <LandingContainer>
        <Header currentTheme={currentTheme} themeToggler={themeToggler} />
        <Masthead />

        <Partners currentTheme={currentTheme} />
        <SupportedNetworks currentTheme={currentTheme} />
        <Achievements />
        <Features />
        <HowItWorks currentTheme={currentTheme} />
        <Compare />
        <GetStarted />
        {/* <Testimony /> */}
        {/* <FAQ /> */}
        <Footer currentTheme={currentTheme} />
      </LandingContainer>
      {modalPage === modalConstants.SelectNetwork ? (
        <SelectNetwork
          connectToNetwork={connectToNetwork}
          currentTheme={currentTheme}
        />
      ) : (
        ""
      )}
    </ParentContainer>
  );
};
